export const useLocalStorageAvailability = (): boolean => {
  try {
    const key = 'checkStorage'
    localStorage.setItem(key, key)
    localStorage.removeItem(key)
    return true
  } catch (e: unknown) {
    console.error(e)
    return false
  }
}
